import { patchApiGalaxyServer } from 'services';

export interface RevertTeamApprovalPayload {
  teamId: string;
  developer?: string; // expect "true" to revert developer approval
  support?: string; // expect "true" to revert support approval
  realmId: string;
  tenant: string;
}

export interface RevertTeamApprovalErrorResponse {
  message: string;
  error: string;
  statusCode: number;
}

export interface RevertTeamApprovalResponse {
  affected: number;
  generatedMaps?: any[];
  raw?: any[];
}

export const revertTeamApprovalApi = ({
  params,
  token,
  config,
}: BaseApiParams<RevertTeamApprovalPayload>) => {
  return patchApiGalaxyServer('/lookup/teams/revert-approval', params, config, token);
};
